import { l } from '@manychat/manyui'

import { appListenerMiddleware } from 'reduxTyped'
import { dropThreadsList } from 'apps/chat/actions/threadsActions'
import { ActionTypes } from 'common/actions'
import { fetchSubscribers } from 'common/audience/actions/audienceThunks'
import { bulkActionRequest } from 'common/audience/actions/bulkActions'
import { audienceSlice } from 'common/audience/audienceSlice'
import { alert } from 'common/core'
import { AudienceBulkActionType } from 'shared/api/requests/audience/schemas'
import { analyticsService } from 'utils/services/analytics'

const automationBulkActions: AudienceBulkActionType[] = [
  ActionTypes.PAUSE_AUTOMATION_FOREVER,
  ActionTypes.RESUME_AUTOMATION,
]

appListenerMiddleware.startListening({
  matcher: bulkActionRequest.fulfilled.match,
  effect: (action, { dispatch }) => {
    const bulkActionType = action.meta.arg.type
    analyticsService.sendEvent('AUDIENCE.BULK_ACTION.SUCCESS', { action: bulkActionType })

    if (!action.payload.async) {
      alert(l.translate('Done!'), 'success')
    }

    if (action.meta.arg.forceListUpdate) {
      dispatch(audienceSlice.actions.dropList())
      dispatch(fetchSubscribers())

      if (automationBulkActions.includes(bulkActionType)) {
        dispatch(dropThreadsList())
      }
    }
  },
})
